import { useEffect } from "react";

// `start` is RETIRED. In the identity-platform model, identity lives at `id`
// (the B2C IdP — where you authenticate), the app + account management live at
// `online`, and products funnel in at `altersvorsorge`. The generic `start`
// landing duplicated the product funnel and had no distinct role, so this
// surface now just forwards old `start.{root}` links to the product home —
// nothing dead-ends. Derive the target from the hostname so every root works
// (start.orgbx.com → altersvorsorge.orgbx.com, start.tenant-a.morfengund.com →
// altersvorsorge.tenant-a.morfengund.com, etc.).
export function App() {
  useEffect(() => {
    const root = window.location.hostname.replace(/^start\./, "");
    window.location.replace(`https://altersvorsorge.${root}/`);
  }, []);

  return (
    <main className="hub-page-header">
      <h1>Redirecting…</h1>
      <p>Taking you to the right place.</p>
    </main>
  );
}

export default App;
